import React from "react";
import "./index.css";

const Table = ({ children, style, className }) => {
  return (
    <table
      className={`Table table${className ? " " + className : ""}`}
      style={style}
    >
      {children}
    </table>
  );
};

const Head = ({ children, style }) => {
  return (
    <thead className={"Table__head"} style={style}>
      {children}
    </thead>
  );
};

const Body = ({ children, style }) => {
  return (
    <tbody className={"Table__body"} style={style}>
      {children}
    </tbody>
  );
};

const Tr = ({ children, style }) => {
  return (
    <tr className="Table__tr" style={style}>
      {children}
    </tr>
  );
};

const Th = ({ children, scope, style, className }) => {
  return (
    <th
      className={`Table__th${className ? " " + className : ""}`}
      scope={scope}
      style={style}
    >
      {children}
    </th>
  );
};

const Td = ({ children, style, className }) => {
  return (
    <td
      className={`Table__td${className ? " " + className : ""}`}
      style={style}
    >
      {children}
    </td>
  );
};

Table.Head = Head;
Table.Body = Body;
Table.Tr = Tr;
Table.Th = Th;
Table.Td = Td;

export default Table;
